/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  useAnalyticChannel
 */

import { useContext } from 'react'

import { AnalyticChannelContext, type AnalyticChannelContextType } from './AnalyticChannelProvider'

export const useAnalyticChannel = (): AnalyticChannelContextType => {
  return useContext(AnalyticChannelContext)
}
